import type { ClientConfig } from '~/api/config/clientConfig';

declare global {
  interface Window {
    __config: ClientConfig;
  }
}

export type Environment = ClientConfig['environment'];

const config = window.__config ?? {
  environment: 'local',
  appVersion: 'unknown',
  isE2eTestMode: false,
};

export const {
  environment,
  isE2eTestMode,
  appVersion,
  appInsightsConnectionString,
  webAuthnEnabled,
  supportNeedsBaseUrl,
} = config;

export const isLocal = environment === 'local';
export const isDev = environment === 'dev';
export const isUat = environment === 'uat';
export const isProd = environment === 'prod';

export const canLoadAppInsights = !!appInsightsConnectionString;
